/**
 * Theme-aware styling utilities.
 *
 * These intentionally stay close to stock MUI: layout and spacing only, with
 * colors left to the theme. Anything visual that MUI already provides
 * (elevation, hover states, palette) is not re-implemented here.
 */

// Card layout. Colors/elevation come from MUI's Card defaults.
export const themedCardStyle = () => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

// Paper padding. Elevation/background come from MUI's Paper defaults.
export const themedPaperStyle = () => ({
  p: { xs: 2, sm: 3, md: 4 },
});

// Button sizing only; MUI handles color and hover.
export const themedButtonStyle = () => ({
  px: { xs: 2.5, sm: 3, md: 3 },
  py: { xs: 1, sm: 1.2, md: 1.5 },
});

// Primary button sizing only. Use variant="contained" color="primary" for color.
export const themedPrimaryButtonStyle = () => ({
  px: { xs: 2.5, sm: 3, md: 3 },
  py: { xs: 1.2, sm: 1.4, md: 1.5 },
});
